import { Link } from 'react-router-dom';

import { alpha, styled } from '@mui/material';

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.mode === 'dark' ? '#F7F7F7' : '#181D27', //TODO: design system
  borderRadius: theme.shape.borderRadius * 10,
  padding: theme.spacing(0, 2),
  background: theme.palette.createBrandGradients.primary(
    theme.palette.mode === 'dark'
      ? {
          alpha1: alpha(theme.palette.common.black, 0.7),
        }
      : {
          alpha1: alpha(theme.palette.common.white, 0.55),
          alpha2: alpha(theme.palette.common.white, 0.55),
        },
  ),
}));

export default StyledLink;
